module.exports = __webpack_public_path__ + "static/media/blazej-ios.c7ce6837.png";